export function formatCurrency(amount) {
  if(amount > 0)  
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(amount);
    else
    return '-'
  }